module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAQFJREFUOE9jZKAyYKSyeQxD0MCbN5+J/ONkXc7IwOBCVHD8//+AkZkpRV1GZC9IPYaXL91/psHKzGJBjGFMDEz2/xn+JzD8//9AQ15MEcXA6/efKzAys2QzMvwXIcYwBgamM8/uXp4ppaw7G2Sohpwo2HFwF9549Po0AwODCXGGQVQxMjDm/GP495WRgXE+NgP/k2IY1MAF/xj+HRw1EBJyNx69piQM+zXkRAXRY5ksA//8/7uXhZGZX11OZCpVDHx293Kqo6PjH1gKoSgd/mdiyNCUEZ2JnNzgBkJyCmsyIwODDKH0+J/x/5//jAxnXty+MhfZdVjzMiHDCMkP/vIQAId+cxXcpgeMAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/icon-board.png
// module id = 2Zcu
// module chunks = 5